import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { hasThreatIntelV2Access } from 'garaje/utils/threat-intel-access';

export default class LocationOverviewCommunicationsThreatDashboardRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  beforeModel(): void {
    // Gated on the same composite predicate the sidebar's Threat intelligence link uses — the
    // global dashboard is v2-only, and rendering it here would leak v2 to companies whose sidebar
    // link is hidden. Falls back to the global message log; there's no pre-v2 fallback on this
    // surface. See utils/threat-intel-access.ts for the shared predicate.
    if (!hasThreatIntelV2Access(this.featureFlags, this.state)) {
      void this.router.transitionTo('location-overview.communications.message-log');
    }
  }
}
